var Namespace = Namespace || (Namespace = {});

Namespace.SingleService = (function ($, window, document) {
	function articles() {
		$("#articlesCarousel").owlCarousel({
			items: 3,
			margin: 30,
			dots: false,
			nav: false,
			responsive: {
				0: {
					items: 1,
					margin: 11,
				},
				768: {
					items: 2,
					margin: 11,
				},
				992: {
					items: 3,
				},
			},
		});
	}

	function works() {
		$("#workCarousel").owlCarousel({
			items: 3,
			margin: 22,
			touchDrag: false,
			mouseDrag: false,
			dots: false,
			nav: true,
			responsive: {
				0: {
					items: 1,
					margin: 11,
					nav: false,
					touchDrag: true,
					mouseDrag: true,
				},
				768: {
					items: 2,
					nav: false,
					touchDrag: true,
					mouseDrag: true,
					margin: 11,
				},
				992: {
					items: 2,
					nav: true,
				},
				1200: {
					items: 3,
					margin: 16,
				},
				1360: {
					margin: 22,
				},
			},
		});
	}

	function workCard() {
		var $container = $(".ourwork__carouselwrap");

		$container.on("touchstart mouseenter focus", ".workcard", function (e) {
			var $this = $(this);

			$this.addClass("active");

			setTimeout(function () {
				$this.addClass("pe-all");
			}, 300);

			// On active item, dont do anything
			if ($this.hasClass("active")) {
				return;
			}

			if (e.type == "touchstart") {
				// Don't trigger mouseenter even if they hold
				e.stopImmediatePropagation();
				// If $item is a link (<a>), don't go to said link on mobile, show menu instead
				e.preventDefault();
			}
		});

		$container.on("mouseleave", ".workcard", function (e) {
			if (!jQuery(e.target).hasClass("workcard")) {
				return;
			}

			var $this = jQuery(this);
			$this.removeClass("pe-all");

			setTimeout(function () {
				$this.removeClass("active");
			}, 75);
		});
	}

	return {
		init: function () {
			articles();
			works();
			workCard();
		},
	};
})(window.jQuery, window, document);
